import { render, staticRenderFns } from "./RelationshipsOrders.vue?vue&type=template&id=26f71e95&"
import script from "./RelationshipsOrders.vue?vue&type=script&lang=js&"
export * from "./RelationshipsOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports